import { useParams } from "react-router-dom";
import i18n from "@/i18n";
import { AuditCard } from "@/features/Audit/AuditCard";
import { EditCardWrapper } from "@/features/Edit/EditCardWrapper";
import { k1PeFundsEditForm } from "./edit_form";

const client = "k1";
const table_name = "k1_pe_funds";

export default function K1PeFundsEdit() {
  const { id } = useParams<{ id: string }>();
  const numericId = Number(id);
  const isValidId = id != null && Number.isInteger(numericId) && numericId > 0;

  if (!isValidId) {
    return <div>{i18n.t("errors.invalid_id")}</div>;
  }

  return (
    <div className="bg-gray-50 min-h-full">
      <div className="flex flex-col gap-10 p-10">
        <EditCardWrapper
          client={client}
          id={numericId}
          headerText={i18n.t(`${table_name}.title`, {
            ns: "tables",
            defaultValue: "PE Fund",
          })}
          {...k1PeFundsEditForm}
        />
        <AuditCard id={numericId} client={client} audit_table_name={table_name} />
      </div>
    </div>
  );
}
